export const shareBetHost: string = 'lvbet.com/sports';
